export default __webpack_public_path__ + "static/media/new_fetch_popup.b9561a4c.png";